<template>
  <div class="main">
    <video ref="media" id="example_video" class="coursevideo" :src="train_video_url" controls="controls" controlslist="nodownload" :poster="curriculumMaterial.img_url">您的浏览器不支持 video 标签。</video>
  </div>
</template>

<script>
import { udpateSchooRemainTraffic } from "@/api/educational";
export default {
  data() {
    return {
      train_video_url: "",

      //流量计算
      cost_num: 0, //流量花费大小
      cost_num_example: 0,
      cost_num_learn: 0,
      type: "", //流量类型  1ppt 2教案 3学生讲义 4录播课视频 5师训视频 6课堂实录 必填
      preview_url: "", //预览地址
      curriculumMaterial: [],
      //定时器
      intervalId: null,
      total_buffertime: 0, //缓冲总时长
      last_buffertime: 0, //上次提交总时长

      intervalId_example: null,
      total_buffertime_example: 0, //缓冲总时长
      last_buffertime_example: 0, //上次提交总时长

      intervalId_learn: null,
      total_buffertime_learn: 0, //缓冲总时长
      last_buffertime_learn: 0 //上次提交总时长
    };
  },

  created() {
    this.train_video_url = this.$route.query.url;
  },
  watch: {
    "this.cost_num_example"(val) {
      console.log(val, 4567);
    }
  },
  mounted() {
    this.dataRefreh_example();

    //绑定页面退出事件
    window.onbeforeunload = e => {
      e = e || window.event;
      if (e) {
        e.returnValue = "关闭提示";
      }
      this.udpateSchooRemainTraffic(); //调用自己的方法
      // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
      return "关闭提示";
    };
  },
  destroyed() {
    // 在页面销毁后，清除计时器
    this.udpateSchooRemainTraffic();

    window.clearInterval(this.intervalId_example); //清除计时器
  },
  methods: {
    dataRefreh_example() {
      // 计时器正在进行中，退出函数
      if (this.intervalId_example != null) {
        return;
      }
      // 计时器为空，操作
      this.intervalId_example = setInterval(() => {
        console.log("刷新" + new Date());

        var example_video = document.getElementById("example_video");

        console.log("课堂实录-视频总时长");
        console.log(example_video.duration);

        console.log("课堂实录-上次缓冲时间");
        console.log(this.last_buffertime_example);

        this.total_buffertime_example = 0;

        for (let k = 0; k < example_video.buffered.length; k++) {
          const offset =
            example_video.buffered.end(k).toFixed(2) -
            example_video.buffered.start(k).toFixed(2);
          this.total_buffertime_example =
            this.total_buffertime_example + offset;
        }

        console.log("课堂实录-本次缓冲时间");
        console.log(this.total_buffertime_example);

        var size = this.$route.query.length;

        console.log("课堂实录-本次缓冲差额");
        console.log(
          this.total_buffertime_example.toFixed(2) -
          this.last_buffertime_example.toFixed(2)
        );

        this.cost_num_example =
          ((this.total_buffertime_example.toFixed(2) -
            this.last_buffertime_example.toFixed(2)) /
            example_video.duration.toFixed(2)) *
          parseFloat(size.substring(0, size.length - 2));

        console.log("课堂实录-原视频大小");
        console.log(size);
        console.log("大小比例:");
        console.log(
          (this.total_buffertime_example.toFixed(2) -
            this.last_buffertime_example.toFixed(2)) /
          example_video.duration.toFixed(2)
        );

        console.log("课堂实录-本次花费流量");
        console.log(this.cost_num_example.toFixed(0));

        console.log("--------------------------");
      }, 6000);
    },
    async udpateSchooRemainTraffic() {
      await udpateSchooRemainTraffic({
        cost_num: this.cost_num_example,
        type: 4,
        lession_id: this.$route.query.id
      }).then(res => {
        console.log(res);
      });
    }
  }
};
</script>

<style>
.main {
  width: 100%;
  /* background: #333; */
}
.coursevideo {
  width: 100%;
  height: 100vh;
  position: relative;
  /* top: 50%;
  left: 50%;
  transform: translateX(-50%);
  background: #333; */

  /* X负数向左平移    Y轴负数往上平移 */
}
/* .container .el-drawer__header {
  margin-bottom: 0px;
  padding: 0px;
  font-weight: bold;
  border-bottom: 0px;
  background: #f9f9f9;
  text-align: center;
}

.el-drawer__header span:focus {
  outline: 0 !important;
} */
</style>